import React from "react";
import View from "../../pages/resetPassword";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  forgot = (email) => {
    this.props.forgotPassword(email).then(() => {
      this.props.history.push("/login");
    });
  };

  render() {
    return <View forgotPassword={this.forgot} />;
  }
}

export default ResetPassword;
